/* © CNES */
import { Slider, SliderChangeEvent } from 'primereact/slider';
import { useContext, useEffect, useState } from 'react';
import { FilterDataContext } from '../../../../../../context/FilterDataContext';
import { CLOUD_COVER } from '../../../../../shared/Constants';
import './InnerSlider.scss';

/**
 * Inner Slider Props.
 */
export interface InnerSliderProps {
  handleChange: (e: any) => void;
}

/**
 * Inner Slider for cloud coverage.
 * @param handleChange Function to handle change when slider is moved.
 * @returns InnerSlider Element.
 */
export const InnerSlider = ({ handleChange }: InnerSliderProps) => {
  const { filterData } = useContext(FilterDataContext);
  const [value, setValue] = useState<any>(filterData[CLOUD_COVER] ?? [0, 100]);

  useEffect(() => {
    const cloudCoverValue = filterData[CLOUD_COVER] ?? [0, 100];
    setValue(cloudCoverValue);
  }, [filterData]);

  /**
   * Move slider handles depending on current cloud cover value.
   */
  useEffect(() => {
    document.querySelectorAll('.p-slider-handle-start').forEach((elem) => {
      elem.innerHTML = `<div class="
      percentNumber positionLeft fontSlider
        ">${value[0]}%</div>`;
    });
    document.querySelectorAll('.p-slider-handle-end').forEach((elem) => {
      elem.innerHTML = `<div class="
      percentNumber positionRight fontSlider
        ">${value[1]}%</div>`;
    });
  }, [value]);

  /**
   * onValueChange when user moves handles.
   * @param event SliderChangeEvent.
   */
  const onValueChange = (event: SliderChangeEvent) => {
    handleChange(event.value);
  };

  return (
    <div className="slider">
      <div className="rangeSlider">
        <span className="minSlider fontSlider">0%</span>
        <span className="maxSlider fontSlider">100%</span>
      </div>
      <div className="sliderBar">
        <Slider
          value={value}
          onChange={(event) => setValue(event.value)}
          className="slider"
          range
          onSlideEnd={onValueChange}
        />
      </div>
    </div>
  );
};
